import { render, staticRenderFns } from "./stock-order.vue?vue&type=template&id=c9e75060&scoped=true"
import script from "./stock-order.vue?vue&type=script&lang=js"
export * from "./stock-order.vue?vue&type=script&lang=js"
import style0 from "./stock-order.vue?vue&type=style&index=0&id=c9e75060&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e75060",
  null
  
)

export default component.exports